import React, { useEffect, useState } from 'react';
import { AutoComplete, Button, Card, Col, Form, Input, Radio, Row } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import banner from '../../Images/planmysurgerybanner2.png';
import WhychooseQuikDr from '../../Images/WhychooseQuikDr.png';
import { useAuth } from '../../Context';
import { selectDepartment } from '../Home/Selectors';
import { fetchDepartmentList } from '../Home/Actions';
import { selectLoading, selectSugeryData, selectTreatmentData } from './Selectors';
import { Content } from 'antd/es/layout/layout';
import CustomSpin from '../CommonSpin';
import { bookSurgicaltreatmentRequest, clearSurgeryData, surgicaltreatmentRequest } from './Actions';
import { useNavigate } from 'react-router-dom';
import { BodyTextHeading, BodyTextValue, ButtonText } from '../CommonText';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';

const PlanMySurgery = () => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [err, setErr] = useState(false);

    const {profileGet, patientDeatils} = useAuth();

    const [formData, setFormData] = useState({
        name: '',
        phoneNumber: '',
        email: '',
        city: '',
        message: '',
        department: '',
        departmentId: [],
        insurance: true,
        surgicaltreatmentId: 0,
        treatment: '',
    });

    useEffect(() => {
        // dispatch({ type: REQUEST_DEPARTMENT_LIST, payload: 'a' });
        // const id = localStorage.getItem('PATIENT_IDS');
        // if (id) dispatch({ type: PROFILE_REQUEST_FRONT });
        profileGet();
    }, [dispatch]);

    const department = useSelector(selectDepartment);
    const surgery = useSelector(selectTreatmentData);
    const profiles = patientDeatils ? patientDeatils[0] : [];
    const requesting = useSelector(selectLoading);
    const surgerySuccess = useSelector(selectSugeryData);

    const [fieldError, setFieldError] = useState({
        fieldName: false,
        fieldPhone: false,
        fieldEmail: false,
        fieldDepartment: false,
        fieldSurgery: false,
    });

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;
    
    useEffect(() => {
        if (profiles) {
            setFormData(prev => ({
                ...prev,
                name: `${profiles.firstName} ${profiles.lastName}`,
                phoneNumber: profiles.primaryContact,
                email: profiles.primaryEmail,
                city: profiles.address,
            }));
        }
    }, [profiles]);

    useEffect(() => {
        dispatch(fetchDepartmentList(null));
        dispatch(clearSurgeryData());
    },[]);

    if(surgerySuccess) {
        navigate('/online-doctors-consultation');
    }

    const validateAndSet = (field, value, regex, errorField) => {
        if (!regex || regex.test(value)) {            
            setFormData(prev => ({ ...prev, [field]: value }));
            setFieldError(prev => ({ ...prev, [errorField]: false }));
        } else {
            setFormData(prev => ({ ...prev, [field]: value }));
            setFieldError(prev => ({ ...prev, [errorField]: true }));
        }
    };

    const handleDepartmentChange = (value) => {
        
        if (!value) {
            setFormData(prev => ({ ...prev, department: '', departmentId: [] }));
        } else {           
            dispatch(surgicaltreatmentRequest(value.value));
            setFormData(prev => ({
                ...prev,
                departmentId: [value.value],
                department: value.label,
            }));
        }
    };

    const handleDepartmentSearch = (value) => {
        
        if (!value) {
            dispatch(fetchDepartmentList(null));
        } else if (value.length >= 1) {
            dispatch(fetchDepartmentList(value));
        }
    };

    const handleSurgeryChange = (value) => {
        if (!value) {
            setFormData(prev => ({ ...prev, surgicaltreatmentId: [], treatment: '' }));
        } else {
            // const { id, name } = JSON.parse(value);
            setFormData(prev => ({
                ...prev,
                surgicaltreatmentId: [value.value],
                treatment: value.label,
            }));
        }
    };

    const handleSubmit = () => {
        const { name, phoneNumber, email, department, treatment } = formData;
        const errors = {
            fieldName: !name,
            fieldPhone: !phoneNumber,
            fieldEmail: !email,
            fieldDepartment: !department,
            fieldSurgery: !treatment,
        };
        
        setFieldError(errors);

        if (Object.values(errors).every(v => !v)) {
            dispatch(bookSurgicaltreatmentRequest(formData));
            setErr(false);
        } else {
            setErr(true);
        }
    };

    const departmentListing = [];
    if (department) {
        department && department?.map((item) => {            
            departmentListing.push({
                value: item.id,
                label: item.specialization
            });
        });
    }

    const surgeryListing = [];
    if (surgery) {
        surgery && surgery?.data.map((item) => {            
            surgeryListing.push({
                value: item.id,
                label: item.name
            });
        });
    }

    const filterOption = (input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

    return (
        <Content style={{ display: 'flex', justifyContent: 'center' }}>
            <Col xs={24} style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                <div style={{ width: '70%' }}>
                    <img style={{ width: '100%' }} src={banner} alt="Banner" />
                </div>
                <Card style={{ width: '70%', borderRadius: 8, boxShadow: '0 0 20px rgba(0,0,0,0.18)' }}>
                    <Row style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <BodyTextHeading text = {langdata.BookMyConsultation ? langdata.BookMyConsultation : 'Book My Consultation'} />
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={handleSubmit}
                            style={{ width: '70%' }}
                        >
                            <Form.Item label={<><BodyTextValue text = {langdata.Enteryourfullname ? langdata.Enteryourfullname : 'Enter your full name '} /><span style={{ color : 'red'}}>&nbsp;*</span> </>} >
                                <Input
                                    size="large"
                                    placeholder={langdata.Name ? langdata.Name : 'Name'}
                                    value={formData.name}
                                    onChange={(e) =>
                                        validateAndSet('name', e.target.value, /^[a-zA-Z ]*$/, 'fieldName')
                                    }
                                />
                                {fieldError.fieldName && <p style={{ color: 'red' }}>{langdata.Pleasefillyourfullname ? langdata.Pleasefillyourfullname : 'Please fill your full name' }</p>}
                            </Form.Item>

                            <Form.Item label={<><BodyTextValue text = {langdata.Enteryourphonenumber ? langdata.Enteryourphonenumber : 'Enter your phone number'} /><span style={{ color : 'red'}}>&nbsp;*</span> </>} >

                                <Input
                                    size="large"
                                    placeholder={langdata.PhoneNumber ? langdata.PhoneNumber : 'Phone Number'}
                                    value={formData.phoneNumber}
                                    onChange={(e) =>
                                        validateAndSet('phoneNumber', e.target.value, /^\d{10}$/, 'fieldPhone')
                                    }
                                />
                                {fieldError.fieldPhone && <p style={{ color: 'red' }}>{langdata.Pleasefillyourphonenumber ? langdata.Pleasefillyourphonenumber : 'Please fill your phone number'}</p>}
                            </Form.Item>

                            <Form.Item label={<><BodyTextValue text = {langdata.EnteryourEmail ? langdata.EnteryourEmail : 'Enter your E-mail'} /><span style={{ color : 'red'}}>&nbsp;*</span> </>} >
                                <Input
                                    size="large"
                                    placeholder={langdata.Email ? langdata.Email : 'Email'}
                                    value={formData.email}
                                    onChange={(e) =>
                                        validateAndSet('email', e.target.value, /^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'fieldEmail')
                                    }
                                />
                                {fieldError.fieldEmail && <p style={{ color: 'red' }}>{langdata.Pleasefillyouremail ? langdata.Pleasefillyouremail : 'Please fill your email' }</p>}
                            </Form.Item>

                            <Form.Item label={langdata.Enteryourcity ? langdata.Enteryourcity : 'Enter your city'}>
                                <Input
                                    size="large"
                                    placeholder={langdata.City ? langdata.City : 'City'}
                                    value={formData.city}
                                    onChange={(e) => setFormData(prev => ({ ...prev, city: e.target.value }))}
                                />
                            </Form.Item>


                            <Form.Item label={<><BodyTextValue text = {langdata.Pleaseselectthedepartment ? langdata.Pleaseselectthedepartment : 'Please select the department'} /><span style={{ color : 'red'}}>&nbsp;*</span> </>} >
                                <AutoComplete
                                    size="large"
                                    onSearch={handleDepartmentSearch}
                                    onChange={(index, options) => {handleDepartmentChange(options);}}
                                    placeholder={langdata.Department ? langdata.Department : 'Department'}
                                    allowClear
                                    options={departmentListing}
                                    value={formData.department}
                                    showSearch
                                    filterOption={filterOption}
                                >
                                </AutoComplete>
                                {fieldError.fieldDepartment && <p style={{ color: 'red' }}>{langdata.Departmentnotselected ? langdata.Departmentnotselected : 'Department not selected' }</p>}
                            </Form.Item>

                            <Form.Item label={<><BodyTextValue text = {langdata.Pleaseselectthesurgery ? langdata.Pleaseselectthesurgery : 'Please select the surgery'} /><span style={{ color : 'red'}}>&nbsp;*</span> </>} >
                                <AutoComplete
                                    size="large"
                                    onChange={(index, options) => {handleSurgeryChange(options);}}
                                    placeholder={langdata.Surgery ? langdata.Surgery : 'Surgery'}
                                    allowClear
                                    options={surgeryListing}
                                    value={formData.treatment}
                                    showSearch
                                    filterOption={filterOption}
                                >
                                </AutoComplete>
                                {fieldError.fieldSurgery && <p style={{ color: 'red' }}>{langdata.Surgerynotselected ? langdata.Surgerynotselected : 'Surgery not selected' }</p>}
                            </Form.Item>

                            <Form.Item label={<BodyTextValue text = {langdata.Pleaseselectyourinsurancestatus ? langdata.Pleaseselectyourinsurancestatus : 'Please select your insurance status'} /> }>
                                <Radio.Group
                                    value={formData.insurance}
                                    onChange={(e) =>
                                        setFormData(prev => ({ ...prev, insurance: e.target.value }))
                                    }
                                >
                                    <Radio value={true}>{langdata.Yes ? langdata.Yes : 'Yes' }</Radio>
                                    <Radio value={false}>{langdata.No ? langdata.No : 'No' }</Radio>
                                </Radio.Group>
                            </Form.Item>

                            <Form.Item label={<BodyTextValue text = {langdata.YourMessageOptional ? langdata.YourMessageOptional : 'Your Message (Optional)'} /> } name="message">
                                <Input
                                    size="large"
                                    placeholder={langdata.Enteramessage ? langdata.Enteramessage : 'Enter a message'}
                                    value={formData.message}
                                    onChange={(e) =>
                                        setFormData(prev => ({ ...prev, message: e.target.value }))
                                    }
                                />
                            </Form.Item>

                            <Form.Item style={{ textAlign: 'center' }}>
                                <Button 
                                    size="large"
                                    onClick={() => {navigate('/online-doctors-consultation');}}
                                >
                                    <ButtonText text = {langdata.Cancel ? langdata.Cancel : 'Cancel'} color = '#00000' />
                                </Button>
                                <Button type="primary" htmlType="submit" size="large" style={{ marginLeft : '20px'}}>
                                    <ButtonText text = {langdata.BookNow ? langdata.BookNow : 'Book Now'} />
                                </Button>
                                {err && <p style={{ color: 'red' }}>{langdata.Pleasefillalltherequiredfields ? langdata.Pleasefillalltherequiredfields : 'Please fill all the required fields' }</p>}
                            </Form.Item>
                        </Form>
                    </Row>
                </Card>
                <div style={{ width: '70%' }}>
                    <img style={{ width: '100%' }} src={WhychooseQuikDr} alt="Why choose QuikDr" />
                </div>
            </Col>
            <CustomSpin spinning = {requesting} />
        </Content>
    );
};

export default PlanMySurgery;
